import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import {
    CLIENTS_ROUTE,
    EDIT_USER_ROUTE,
    GROUPS_ROUTE,
    LOGIN_ROUTE,
    LS_CURRENT_USER,
    LS_SESSION_JWT,
    MEETINGS_ROUTE,
    PUBLIC_SUBSCRIPTIONS_ROUTE,
    TEMPLATES_ROUTE,
    USERS_ROUTE,
} from "../../constants";
import { removeCurrentUser, setAuthJwt } from "../../redux/auth/authActions";
import "./../../styles/projectNavbar.css";
import revize_logo from "./../../assets/revize-logo.svg";

const ProjectNavbar = () => {
    const currentUser = useSelector((state) => state.authReducer.currentUser);
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();

    function handleLogout(e) {
        e.preventDefault();
        dispatch(setAuthJwt(null));
        dispatch(removeCurrentUser());
        localStorage.removeItem(LS_SESSION_JWT);
        localStorage.removeItem(LS_CURRENT_USER);

        history.push(LOGIN_ROUTE);
    }

    return (
        <div>
            <Navbar light expand="md" className="mt-2">
                <NavbarBrand href="/">
                    <img src={revize_logo} alt="revize logo" />
                </NavbarBrand>
                <NavbarToggler
                    onClick={() => {
                        setIsOpen(!isOpen);
                    }}
                />
                <Collapse
                    isOpen={isOpen}
                    className="project-navbar-collapse mt-2"
                    navbar
                >
                    <Nav className="mr-auto" navbar>
                        <NavItem>
                            <NavLink href={MEETINGS_ROUTE}>Meetings</NavLink>
                        </NavItem>
                        {currentUser.role !== "USER" ? (
                            <NavItem>
                                <NavLink href={TEMPLATES_ROUTE}>
                                    Templates
                                </NavLink>
                            </NavItem>
                        ) : null}
                        {currentUser.role === "SUPERUSER" ? (
                            <NavItem>
                                <NavLink href={CLIENTS_ROUTE}>Clients</NavLink>
                            </NavItem>
                        ) : null}
                        <NavItem>
                            <NavLink href={GROUPS_ROUTE}>Groups</NavLink>
                        </NavItem>
                        {currentUser.role !== "USER" ? (
                            <NavItem>
                                <NavLink href={PUBLIC_SUBSCRIPTIONS_ROUTE}>
                                    Public Subscriptions
                                </NavLink>
                            </NavItem>
                        ) : null}
                        <NavItem>
                            <NavLink href={USERS_ROUTE}>Users</NavLink>
                        </NavItem>
                        <UncontrolledDropdown className="ml-auto" nav inNavbar>
                            <DropdownToggle nav caret>
                                {currentUser.first_name +
                                    " " +
                                    currentUser.last_name}
                            </DropdownToggle>
                            <DropdownMenu end>
                                <DropdownItem>
                                    <NavItem>
                                        <NavLink
                                            href={EDIT_USER_ROUTE.replace(
                                                ":id",
                                                currentUser.id
                                            )}
                                        >
                                            Profile
                                        </NavLink>
                                    </NavItem>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavItem>
                                        <NavLink
                                            href={LOGIN_ROUTE}
                                            onClick={handleLogout}
                                        >
                                            Logout
                                        </NavLink>
                                    </NavItem>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Nav>
                </Collapse>
            </Navbar>
            <hr />
        </div>
    );
};

export default ProjectNavbar;
